export interface Pushpin {
  id: string;
  model?: any;
  modelObjectId: number;
  title?: string;
  description?: string;
  name?: string;
  color?: string;
}
